// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bam_a"};